// extracted by mini-css-extract-plugin
export default {"title":"O_-z","warning":"P_-z","sizeOptionsLegendText":"Q_-z"};